"use client";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import Link from "next/link";
import { MdErrorOutline } from "react-icons/md";

// 予約情報の登録・変更フォームへ遷移する前の確認内容
// Dialog（DialogContent）の中に配置して使用する
export const ReservationConfirmContent = ({
  title,
  description,
  reservationFormUrl,
  confirmLabel,
  confirmLabelWide,
  onBack,
}: {
  title: string;
  description: string;
  reservationFormUrl: string;
  // 確認ボタンのラベル（狭幅時）
  confirmLabel: string;
  // 確認ボタンのラベル（広幅時）
  confirmLabelWide: string;
  onBack: () => void;
}) => {
  return (
    <>
      <div className="shrink-0 border-b border-monotone-2 px-6 pt-6 pb-4 md:px-8 md:pt-8">
        <DialogTitle className="flex items-center gap-2 text-lg font-bold text-error md:text-xl">
          <MdErrorOutline className="h-6 w-6 shrink-0 fill-error stroke-white" />
          {title}
        </DialogTitle>
      </div>
      <div className="space-y-6 overflow-y-auto px-6 pt-6 pb-6 md:px-8 md:pb-8">
        <p className="text-sm">{description}</p>
        <div className="grid grid-cols-2 gap-3">
          <Button variant="default" className="h-12 md:h-14" onClick={onBack}>
            戻る
          </Button>
          <Button variant="primary" className="h-12 md:h-14" asChild>
            <Link
              href={reservationFormUrl}
              className="flex items-center justify-center text-sm md:text-base"
            >
              <span className="md:hidden">{confirmLabel}</span>
              <span className="hidden md:inline">{confirmLabelWide}</span>
            </Link>
          </Button>
        </div>
      </div>
    </>
  );
};

// 予約情報の登録・変更フォームへ遷移する前に単体で表示する確認ダイアログ
export const ReservationConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  reservationFormUrl,
  confirmLabel,
  confirmLabelWide,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  reservationFormUrl: string;
  confirmLabel: string;
  confirmLabelWide: string;
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="mx-auto flex max-h-[80vh] max-w-[calc(100vw-3rem)] flex-col gap-0 p-0 md:max-w-xl"
        aria-describedby={undefined}
      >
        <ReservationConfirmContent
          title={title}
          description={description}
          reservationFormUrl={reservationFormUrl}
          confirmLabel={confirmLabel}
          confirmLabelWide={confirmLabelWide}
          onBack={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
